import { Routes } from '@angular/router';
import { DashboardsComponent } from './feactures-modules/dashboards/dashboards.component';
import { EfetivosComponent } from './feactures-modules/efetivos/efetivos.component';
import { PostosComponent } from './feactures-modules/postos/postos.component';
import { PostoDetailComponent } from './feactures-modules/postos/posto-detail/posto-detail.component';
import { CriarPostoComponent } from './feactures-modules/postos/criar-posto/criar-posto.component';
import { DetalheEfetivoComponent } from './feactures-modules/efetivos/detalhe-efetivo/detalhe-efetivo.component';
import { EditarEfetivoComponent } from './feactures-modules/efetivos/editar-efetivo/editar-efetivo.component';
import { DetalheEquipamentoComponent } from './feactures-modules/equipamentos/detalhe-equipamento/detalhe-equipamento.component';
import { NovoEquipamentoComponent } from './feactures-modules/equipamentos/novo-equipamento/novo-equipamento.component';
import { ViaturasPageComponent } from './feactures-modules/equipamentos/viaturas/viaturas.component';
import { ArmasPageComponent } from './feactures-modules/equipamentos/armas/armas.component';
import { UtensiliosPageComponent } from './feactures-modules/equipamentos/utensilios/utensilios.component';
import { TiposEquipamentoComponent } from './feactures-modules/equipamentos/tipos-equipamento/tipos-equipamento.component';
import { FinanceiroComponent } from './feactures-modules/financeiro/financeiro.component';
import { FaturaWizardComponent } from './feactures-modules/financeiro/components/fatura-wizard/fatura-wizard.component';
import { FaturaDetalheComponent } from './feactures-modules/financeiro/components/fatura-detalhe/fatura-detalhe.component';
import { OcorrenciasComponent } from './feactures-modules/ocorrencias/ocorrencias.component';
import { AlertasComponent } from './feactures-modules/alertas/alertas.component';
import { CriarEfetivoComponent } from './feactures-modules/efetivos/criar-efetivo/criar-efetivo.component';
import { EscalasComponent } from './feactures-modules/escalas/escalas.component';
import { NovaEscalaComponent } from './feactures-modules/escalas/nova-escala/nova-escala.component';
import { EscalaDetailComponent } from './feactures-modules/escalas/escala-detail/escala-detail.component';
import { RondasComponent } from './feactures-modules/rondas/rondas.component';
import { ClientesComponent } from './feactures-modules/clientes/clientes.component';
import { DetalheClienteComponent } from './feactures-modules/clientes/detalhe-cliente/detalhe-cliente.component';
import { ClienteNovoComponent } from './feactures-modules/clientes/cliente-novo/cliente-novo.component';
import { ContratosComponent } from './feactures-modules/contratos/contratos.component';
import { ContratoNovoComponent } from './feactures-modules/contratos/contrato-novo/contrato-novo.component';
import { ConfiguracoesComponent } from './feactures-modules/configuracoes/configuracoes.component';
import { UtilizadoresComponent } from './feactures-modules/utilizadores/utilizadores.component';
import { PermissoesComponent } from './feactures-modules/permissoes/permissoes.component';
import { RelatoriosComponent } from './feactures-modules/relatorios/relatorios.component';
import { PostoComandoComponent } from './feactures-modules/posto-comando/posto-comando.component';
import { RegistosComponent } from './feactures-modules/registos/registos.component';

export const Adminroutes: Routes = [
  {
    path: 'dashboards',
    component: DashboardsComponent,
    data: { breadcrumb: 'Dashboards' },
  },
  {
    path: 'efetivos',
    data: { breadcrumb: 'Efetivos' },
    children: [
      { path: '', component: EfetivosComponent },
      {
        path: 'novo-efetivo',
        component: CriarEfetivoComponent,
        data: { breadcrumb: 'Novo Efetivo' },
      },
      {
        path: ':id',
        component: DetalheEfetivoComponent,
        data: { breadcrumb: 'Detalhe' },
      },
      {
        path: ':id/editar',
        component: EditarEfetivoComponent,
        data: { breadcrumb: 'Editar Efetivo' },
      },
    ],
  },
  {
    path: 'postos',
    data: { breadcrumb: 'Postos' },
    children: [
      { path: '', component: PostosComponent },
      {
        path: 'novo',
        component: CriarPostoComponent,
        data: { breadcrumb: 'Novo Posto' },
      },
      {
        path: ':id',
        component: PostoDetailComponent,
        data: { breadcrumb: 'Detalhe do Posto' },
      },
      {
        path: ':id/editar',
        component: CriarPostoComponent,
        data: { breadcrumb: 'Editar Posto' },
      },
    ],
  },
  {
    path: 'equipamentos',
    data: { breadcrumb: 'Equipamentos' },
    children: [
      { path: '', redirectTo: 'viaturas', pathMatch: 'full' },
      {
        path: 'viaturas',
        component: ViaturasPageComponent,
        data: { breadcrumb: 'Viaturas' },
      },
      {
        path: 'armas',
        component: ArmasPageComponent,
        data: { breadcrumb: 'Armas' },
      },
      {
        path: 'utensilios',
        component: UtensiliosPageComponent,
        data: { breadcrumb: 'Utensílios' },
      },
      {
        path: 'tipos',
        component: TiposEquipamentoComponent,
        data: { breadcrumb: 'Tipos' },
      },
      {
        path: 'novo',
        component: NovoEquipamentoComponent,
        data: { breadcrumb: 'Novo Equipamento' },
      },
      {
        path: ':id',
        component: DetalheEquipamentoComponent,
        data: { breadcrumb: 'Detalhe' },
      },
      {
        path: ':id/editar',
        component: NovoEquipamentoComponent,
        data: { breadcrumb: 'Editar Equipamento' },
      },
    ],
  },
  {
    path: 'clientes',
    data: { breadcrumb: 'Clientes' },
    children: [
      { path: '', component: ClientesComponent },
      {
        path: 'novo',
        component: ClienteNovoComponent,
        data: { breadcrumb: 'Novo Cliente' },
      },
      {
        path: ':id',
        component: DetalheClienteComponent,
        data: { breadcrumb: 'Perfil do Cliente' },
      },
    ],
  },
  {
    path: 'financeiro',
    data: { breadcrumb: 'Financeiro' },
    children: [
      { path: '', component: FinanceiroComponent },
      {
        path: 'nova',
        component: FaturaWizardComponent,
        data: { breadcrumb: 'Nova Fatura' },
      },
      {
        path: ':id',
        component: FaturaDetalheComponent,
        data: { breadcrumb: 'Detalhe da Fatura' },
      },
      {
        path: ':id/editar',
        component: FaturaWizardComponent,
        data: { breadcrumb: 'Editar Fatura' },
      },
      {
        path: ':id/corrigir',
        component: FaturaWizardComponent,
        data: { breadcrumb: 'Corrigir Fatura' },
      },
    ],
  },
  {
    path: 'ocorrencias',
    component: OcorrenciasComponent,
    data: { breadcrumb: 'Ocorrências' },
  },
  {
    path: 'posto-comando',
    component: PostoComandoComponent,
    data: { breadcrumb: 'Posto de Comando' },
  },
  {
    path: 'alertas',
    component: AlertasComponent,
    data: { breadcrumb: 'Alertas' },
  },
  {
    path: 'escalas',
    data: { breadcrumb: 'Escalas' },
    children: [
      { path: '', component: EscalasComponent },
      {
        path: 'nova',
        component: NovaEscalaComponent,
        data: { breadcrumb: 'Nova Escala' },
      },
      {
        path: ':id',
        component: EscalaDetailComponent,
        data: { breadcrumb: 'Detalhe' },
      },
    ],
  },
  {
    path: 'rondas',
    component: RondasComponent,
    data: { breadcrumb: 'Rondas' },
  },
  {
    path: 'contratos',
    data: { breadcrumb: 'Contratos' },
    children: [
      { path: '', component: ContratosComponent },
      {
        path: 'novo',
        component: ContratoNovoComponent,
        data: { breadcrumb: 'Novo Contrato' },
      },
    ],
  },
  {
    path: 'utilizadores',
    data: { breadcrumb: 'Utilizadores' },
    children: [
      {
        path: '',
        component: UtilizadoresComponent,
      },
    ],
  },
  {
    // TODO: guard VISUALIZAR_UTILIZADORES quando existir mecanismo de guarda por role.
    path: 'permissoes',
    data: { breadcrumb: 'Permissões' },
    children: [
      {
        path: '',
        component: PermissoesComponent,
      },
    ],
  },
  {
    path: 'configuracoes',
    component: ConfiguracoesComponent,
    data: { breadcrumb: 'Configurações' },
  },
  {
    path: 'relatorios',
    component: RelatoriosComponent,
    data: { breadcrumb: 'Relatórios', moduleName: 'Relatórios' },
  },
  {
    path: 'registos',
    component: RegistosComponent,
    data: { breadcrumb: 'Registos de Atividade' },
  },
];
